import axios from "axios";
import config from "./config/local";
import * as GeneralFunctions from "./GeneralFunctions";

export const request = async (obj) => {
  let headers = {};
  let authorization =
    obj.token === "marketplaceAccessToken"
      ? localStorage.getItem("marketplaceAuthorization")
      : localStorage.getItem("authorization");
  if (authorization) headers["Authorization"] = authorization;
  let user = GeneralFunctions.getAuthUser();
  let permission = GeneralFunctions.getPermissions();
  if (obj.method === "GET" || obj.method === "get") {
    if (
      user &&
      user.connectedUser &&
      user.connectedUser.hasOwnProperty("SPIEvent")
    )
      Object.assign(obj, {
        params: { ...obj.params, SPIEvent: user.connectedUser.SPIEvent },
      });
  } else {
    if (
      user &&
      user.connectedUser &&
      user.connectedUser.hasOwnProperty("SPIEvent")
    ) {
      if (obj.data instanceof FormData) {
        obj.data.append("SPIEvent", user.connectedUser.SPIEvent);
      } else {
        Object.assign(obj, {
          data: { ...obj.data, SPIEvent: user.connectedUser.SPIEvent },
        });
      }
    }
  }
  try {
    if (obj.params) {
      for (let param in obj.params) {
        if (
          typeof obj.params[param] === "undefined" ||
          obj.params[param] === null
        ) {
          delete obj.params[param];
        }
      }
    }
    const response = await axios.create({
      baseURL: config.server.url,
      headers: headers,
    })(obj);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401) {
        GeneralFunctions.clearFullLocalStorage();
        if (permission === "rushUser") {
          window.location.assign(`${window.location.origin}/userlogin`);
        } else {
          // window.location.assign(`${window.location.origin}/admin/login`);
        }
      }
      if (error.response.data && error.response.data.message) {
        throw Error(error.response.data.message);
      }
    } else {
      throw Error("Server error.");
    }
    throw Error("Internet error.");
  }
};

export const serverRequest = async (obj) => {
  let headers = {};
  let authorization = localStorage.getItem("authorization");
  if (authorization) headers["Authorization"] = authorization;
  let user = GeneralFunctions.getAuthUser();
  let permission = GeneralFunctions.getPermissions();
  if (obj.method === "GET" || obj.method === "get") {
    if (
      user &&
      user.connectedUser &&
      user.connectedUser.hasOwnProperty("SPIEvent")
    )
      Object.assign(obj, {
        params: { ...obj.params, SPIEvent: user.connectedUser.SPIEvent },
      });
  } else {
    if (
      user &&
      user.connectedUser &&
      user.connectedUser.hasOwnProperty("SPIEvent")
    ) {
      if (obj.data instanceof FormData) {
        obj.data.append("SPIEvent", user.connectedUser.SPIEvent);
      } else {
        Object.assign(obj, {
          data: { ...obj.data, SPIEvent: user.connectedUser.SPIEvent },
        });
      }
    }
  }
  try {
    if (obj.params) {
      for (let param in obj.params) {
        if (
          typeof obj.params[param] === "undefined" ||
          obj.params[param] === null
        ) {
          delete obj.params[param];
        }
      }
    }
    const response = await axios.create({
      baseURL: config.server.zocialServerUrl,
      headers: headers,
    })(obj);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401) {
        GeneralFunctions.clearFullLocalStorage();
        if (permission === "rushUser") {
          window.location.assign(`${window.location.origin}/userlogin`);
        } else {
          window.location.assign(`${window.location.origin}/admin/login`);
        }
      }
      if (error.response.data && error.response.data.message) {
        throw Error(error.response.data.message);
      }
    } else {
      throw Error("Server error.");
    }
    throw Error("Internet error.");
  }
};

export const staticTokenServerRequest = async (obj, applyStaticToken) => {
  let headers = {};
  if (applyStaticToken)
    headers["Authorization"] = `Bearer ${config.staticToken}`;
  let user = GeneralFunctions.getAuthUser();
  if (obj.method === "GET" || obj.method === "get") {
    if (
      user &&
      user.connectedUser &&
      user.connectedUser.hasOwnProperty("SPIEvent")
    )
      Object.assign(obj, {
        params: { ...obj.params, SPIEvent: user.connectedUser.SPIEvent },
      });
  } else {
    if (
      user &&
      user.connectedUser &&
      user.connectedUser.hasOwnProperty("SPIEvent")
    ) {
      if (obj.data instanceof FormData) {
        obj.data.append("SPIEvent", user.connectedUser.SPIEvent);
      } else {
        Object.assign(obj, {
          data: { ...obj.data, SPIEvent: user.connectedUser.SPIEvent },
        });
      }
    }
  }
  try {
    if (obj.params) {
      for (let param in obj.params) {
        if (
          typeof obj.params[param] === "undefined" ||
          obj.params[param] === null
        ) {
          delete obj.params[param];
        }
      }
    }
    const response = await axios.create({
      baseURL: config.server.zocialServerUrl,
      headers: headers,
    })(obj);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401) {
        GeneralFunctions.clearFullLocalStorage();
        window.location.assign(`${window.location.origin}/admin/login`);
      }
      if (error.response.data && error.response.data.message) {
        throw Error(error.response.data.message);
      }
    } else {
      throw Error("Server error.");
    }
    throw Error("Internet error.");
  }
};
export const chatServerRequest = async (obj) => {
  let headers = {};
  let authorization = localStorage.getItem("chatAuthorizationHeader");
  if (authorization) headers["Authorization"] = authorization;
  let user = GeneralFunctions.getAuthUser();
  try {
    if (obj.params) {
      for (let param in obj.params) {
        if (
          typeof obj.params[param] === "undefined" ||
          obj.params[param] === null
        ) {
          delete obj.params[param];
        }
      }
    }
    const response = await axios.create({
      baseURL: config.server.chatServerUrl,
      headers: headers,
    })(obj);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401) {
        GeneralFunctions.clearFullLocalStorage();
        window.location.assign(`${window.location.origin}/admin/login`);
      }
      if (error.response.data && error.response.data.message) {
        throw Error(error.response.data.message);
      }
      if (
        error.response.data &&
        !error.response.data.success &&
        error.response.data.error
      ) {
        throw Error(error.response.data.error);
      }
    } else {
      throw Error("Server error.");
    }
    throw Error("Internet error.");
  }
};
